<template>
    <div>
        <el-page-header @back="goBack" content="奖品发放及消耗报表">
        </el-page-header>
        <div class="block" style="margin-top: 25px" >
            <span class="demonstration">日期：</span>
            <el-date-picker
                    v-model="queryData.timeDate"
                    type="daterange"
:clearable="false"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
            </el-date-picker>&emsp;&emsp;
            <el-button  type="primary" @click="searchPrizeReport" >查询</el-button>
            <!-- <el-button  type="primary" @click="exportExcel()" >导出报表</el-button> -->
        </div>

        <h1>
            <el-table border :data="prizeReport"
                      :header-cell-style="{background:'#282828'}"
                      ref="filterTable" 
                      max-height="820">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="NAME" width="150" label="期数"  ></el-table-column>
                <el-table-column  prop="type" label="奖品类型"  :formatter="typeFormatter" ></el-table-column>
                <el-table-column prop="prizeName"  label="奖品名称" > </el-table-column>
                <!-- <el-table-column prop=" "  label="单用户发放数量" > </el-table-column> -->
                <el-table-column prop="totalSendCount"  label="总发放数量" >
                    <template slot-scope="scope" >
                        {{ scope.row.totalSendCount == null ? 0 : scope.row.totalSendCount  }}
                    </template>
                </el-table-column>
                <el-table-column prop="offerPrizeNumber"  label="已发送数量"  >
                    <template slot-scope="scope" >
                        {{ scope.row.offerPrizeNumber == null ? 0 : scope.row.offerPrizeNumber  }}
                    </template>
                </el-table-column>
                <el-table-column  prop="offerPrizeUserNumber" label="已发送用户数" >
                    <template slot-scope="scope" >
                        {{ scope.row.offerPrizeUserNumber == null ? 0 : scope.row.offerPrizeUserNumber  }}
                    </template>
                </el-table-column>
                <el-table-column  prop="usePrizeNumber" label="已使用数量">
                    <template slot-scope="scope" >
                        {{ scope.row.usePrizeNumber == null ? 0 : scope.row.usePrizeNumber  }}
                    </template>
                </el-table-column>
                <el-table-column  prop="usePrizeUserNumber" label="已使用用户数"  >
                    <template slot-scope="scope" >
                        {{ scope.row.usePrizeUserNumber == null ? 0 : scope.row.usePrizeUserNumber  }}
                    </template>
                </el-table-column>
                <!-- todo  计算 -->
                <el-table-column    label="人均发放数量"   >
                    <template slot-scope="scope" >
                        {{ (scope.row.offerPrizeUserNumber == null ||  scope.row.offerPrizeNumber == null) ? "0.00" : formatFloat(scope.row.offerPrizeNumber / scope.row.offerPrizeUserNumber,2)}}
                    </template>
                </el-table-column>
                <el-table-column    label="人均使用数量" >
                    <template slot-scope="scope" >
                        {{ (scope.row.usePrizeUserNumber == null ||  scope.row.usePrizeNumber == null) ? "0.00" : formatFloat(scope.row.usePrizeNumber / scope.row.usePrizeUserNumber,2)   }}
                    </template>
                </el-table-column>
            </el-table>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pagenum"
                        :page-sizes="[10,20,30,50]"
                        :page-size="queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next"
                        :total="queryInfo.total">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
    import { 
        searchPrizeReport,
        downloadData ,
        typePacketInfo
    }from "@/http/api";
    import utils from '@/utils'

    export default {
        name: "PrizeReport",
        data(){
           return{ 
               prizeReport:[],
               dialogMaterialVisible:false,
               queryData:{ 
                   timeDate:['',''],
               },
               queryTrueData:{ 
                   startTime:'',
                   endTime:'', 
               },
               queryInfo:{
                   pagesize:10,
                   pagenum:1,
                   total:0,
               },
               typeValues: [ ], 
           }
        },
       methods:{
           typeFormatter: function (row, column, cellValue){
            var temp="其他"
            this.typeValues.forEach( item => {
                if(item.id===cellValue){
                    temp=item.name;
                    } 
            })
            return temp
            },
           formatFloat(src, pos)
           {
             return Math.round(src*Math.pow(10, pos))/Math.pow(10, pos);
           },
           handleSizeChange(newSize){
               this.queryInfo.pagesize=newSize;
                this.searchPrizeReport();
           },
           goBack() {
               this.$router.push({path: '/ActivitySummary'})
           },
           handleCurrentChange(newPage){
               this.queryInfo.pagenum=newPage;
                this.searchPrizeReport();
           },
           searchPrizeReport(){
               if (this.queryData.timeDate===null){
                   this.queryData.timeDate=['',''];
               }  
               this.queryTrueData.startTime= this.queryData.timeDate[0];
               this.queryTrueData.endTime=this.queryData.timeDate[1];
               this.queryTrueData.size=this.queryInfo.pagesize;
               this.queryTrueData.page=this.queryInfo.pagenum;
               //todo order type
               searchPrizeReport(this.queryTrueData).then(resp=>{
                 this.prizeReport=resp.data.info.content;
                   this.queryInfo.total=resp.data.info.totalElements;
               });
           },
         exportExcel () {
             let fileName = new Date().toLocaleString()+'奖品发放报表.xlsx';
           downloadData(
               '/data/searchPrizeReportExcel',
               Object.assign(this.queryTrueData),
               fileName
           )
         }
       },
       created(){
        this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
        this.searchPrizeReport();
        typePacketInfo().then(resp => {
       this.typeValues=resp.data.info
     }) 
       }
    }
</script>

<style scoped>

</style>
